/**=========================================================
 * Module: wait.js
 * Wait Controller
 =========================================================*/

 App.controller("WaitController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService",
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) 
 {
   "use strict";

   $scope.type = "wait";
   $scope.id = $state.params.filter;
   
   $scope.page = {
     title: "labels.WAITPROJECT",
     subTitle: ""
   };

   $scope.awaited = {};
   $scope.projects = {};

   function loadProjects(d){
    D.query('project', '_waiting='+$scope.id+'&_waitingD='+d).then(function(response){
      $scope.projects[d] = response;
      for(var i=0; i<response.length; i++){
        var p = response[i];
        $scope.awaited[d][p.id] = {
          wait: null,
          status: ''
        }
        if(p.status=='PROCESSING' || p.status=='CONFIRMED'){
          var lt = function(p, d){
            D.load('translation', p.id + '-' + p.source + '-' + d).then(function(r){
              $scope.awaited[d][p.id].translation = r.status;
            }).catch(console.error);
          }(p, d);
        }
      }
      loadWaits(d);
     }).catch(console.error);
   }

   function loadWaits(d){
    D.query('wait','waiting='+$scope.id+'&destination='+d, { cache: false }).then(function(response){
      for(var i=0; i<response.length; i++){
        $scope.awaited[d][response[i].awaited].wait = true;
      }
    }).catch(console.error);
   }

   D.load('project', $scope.id).then(function(response){
     $scope.waiting = response;
     $scope.page.subTitle = $scope.waiting.name;
     for(var i=0; i<$scope.waiting.destinations.length; i++){
       var d = $scope.waiting.destinations[i];
       $scope.awaited[d] = {};
       loadProjects(d);
     }
     
   }).catch(console.error);

   $scope.setWait = function(d,id){
    $scope.awaited[d][id].status = 'status-pending';
     if($scope.awaited[d][id].wait){
       D.save('wait', {
         awaited: id,
         waiting: $scope.id,
         source: $scope.waiting.source,
         destination: d
       }).then(function(res){
         $scope.awaited[d][id].status = '';
       }).catch(function(err){
         $scope.awaited[d][id].status = 'status-error';
       });
     } else {
       D.remove('wait', id + '-' + $scope.waiting.source + '-' + d + '-' + $scope.id).then(function(res){
        $scope.awaited[d][id].status = '';
      }).catch(function(err){
        $scope.awaited[d][id].status = 'status-error';
      });
     }
   }

   
 }
]);
